import type { HostingRemoteBackupView } from '@tosho/contracts';
import { PrototypeIcon } from './PrototypeIcon';

export function HostingSiteBackupSummary({
  value,
}: {
  readonly value: HostingRemoteBackupView | null | undefined;
}): React.JSX.Element {
  const latest = value?.recent[0];
  return (
    <div className="hosting-backup-summary">
      <span className="hosting-backup-summary__label">
        <PrototypeIcon name="database" />
        Google Drive
      </span>
      <strong>
        {latest
          ? backupDate(latest.pointKey)
          : value?.presence === 'EMPTY'
            ? 'Aucune copie sur Google Drive'
            : 'Dernière sauvegarde inconnue'}
      </strong>
      {value?.hasUnverifiedCopies && (
        <small>Dernière copie confirmée · autres copies à vérifier dans Plesk</small>
      )}
      <small
        className={
          value?.presence === 'PRESENT' ? 'hosting-backup-summary__presence is-present' : undefined
        }
      >
        {backupPresence(value)}
      </small>
      <small>{backupSchedule(value?.schedule)}</small>
    </div>
  );
}

export function backupPresence(value: HostingRemoteBackupView | null | undefined): string {
  if (value?.presence === 'PRESENT') return 'Présence confirmée sur Google Drive';
  if (value?.presence === 'EMPTY') return 'Aucune copie retournée par Google Drive';
  return value?.observedAt
    ? 'Présence sur Google Drive à revérifier'
    : 'Présence sur Google Drive non vérifiée';
}

export function backupSchedule(
  value: HostingRemoteBackupView['schedule'] | undefined,
  scope: 'SERVER' | 'VHOST' = 'VHOST',
): string {
  if (!value?.isCurrent || value.state === 'UNKNOWN') return 'Programmation Plesk indisponible';
  if (value.state === 'DISABLED')
    return scope === 'VHOST'
      ? 'Pas de programmation Google Drive propre à cet abonnement'
      : 'Aucune sauvegarde Google Drive programmée pour le serveur';
  const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  return (
    value.plans
      .map((plan) => {
        if (plan.period === 'HOURLY')
          return plan.everyHours === 1
            ? 'Toutes les heures'
            : `Toutes les ${plan.everyHours} heures`;
        const at = plan.at!;
        if (plan.period === 'DAILY') return `Chaque jour à ${at}`;
        if (plan.period === 'WEEKLY') return `Chaque ${days[plan.weekday!]} à ${at}`;
        return `Chaque mois, ${plan.monthDay === 'FIRST' ? 'le premier jour' : plan.monthDay === 'LAST' ? 'le dernier jour' : `le ${plan.monthDay}`} à ${at}`;
      })
      .join(' · ') + ' (heure du serveur)'
  );
}
export function backupDate(value: string): string {
  return `${value.slice(4, 6)}/${value.slice(2, 4)}/20${value.slice(0, 2)} ${value.slice(6, 8)}:${value.slice(8, 10)}`;
}
